import { data } from '../../svg/Raven/data';
import { makeIcon } from '../makeIcon';

export const Raven = makeIcon(data, 'raven', 'Raven');

export default Raven;
